(function ($) {

    function filterObce(okresId) {
        $('#modal #input-ObecId[data-wp-filter] option[data-okres-id]').hide();
        if (okresId) {
            $('#modal #input-ObecId[data-wp-filter] option[data-okres-id="' + okresId + '"]').show();
        }
    }

    function filterCastiObce(obecId) {
        $('#modal #input-CastObceId[data-wp-filter] option[data-obec-id]').hide();
        if (obecId) {
            $('#modal #input-CastObceId[data-wp-filter] option[data-obec-id="' + obecId + '"]').show();
        }
    }

    function resetCastiObce() {
        $('#modal #input-CastObceId[data-wp-filter] option[data-obec-id]').hide();
        $('#modal #input-CastObceId[data-wp-filter] option:first').prop('selected', true);
    }

    $(document).on('change', '#modal #input-OkresId[data-wp-filter]', function () {
        const okresId = $(this).val();
        filterObce(okresId);
        $('#modal #input-ObecId[data-wp-filter] option:first').prop('selected', true);
        resetCastiObce();
    }).on('change', '#modal #input-ObecId', function () {
        const obecId = $(this).val();
        filterCastiObce(obecId);
        $('#modal #input-CastObceId[data-wp-filter] option:first').prop('selected', true);
    });

    function initAdresaSelects() {
        const okresId = $('#modal #input-OkresId[data-wp-filter]').val();
        const obecId = $('#modal #input-ObecId[data-wp-filter]').val();

        filterObce(okresId);
        filterCastiObce(obecId);
    }

    window.initModalAdresaSelects = initAdresaSelects;


})(jQuery);
